// @flow

import PropTypes from 'prop-types';
import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import { AccessibleElement } from '@zapier/legacy-components';
import { Icon } from '@zapier/common-components';

import AccountInfo from 'web-ssr/app/common/components/AccountInfo';
import 'web-ssr/app/common/components/AccountDropdownToggler/AccountDropdownToggler.scss';

const bem = bemify('account-dropdown-toggler');

const AccountDropdownToggler = (props: Object) => (
  <AccessibleElement.Div
    className={bem(toModifiers(props.kind), props.className)}
    onClick={props.onClick}
  >
    <AccountInfo {...props} />
    {props.hideArrow === true ? null : (
      <Icon className={bem('__arrow')} name="arrow-down" />
    )}
  </AccessibleElement.Div>
);

AccountDropdownToggler.propTypes = {
  accountId: PropTypes.number,
  meta: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  hideArrow: PropTypes.bool,
  hideDetails: PropTypes.bool,
};

export default AccountDropdownToggler;
